import { render, staticRenderFns } from "./u8.icon.uploader.vue?vue&type=template&id=283bb38f&"
import script from "./u8.icon.uploader.vue?vue&type=script&lang=js&"
export * from "./u8.icon.uploader.vue?vue&type=script&lang=js&"
import style0 from "./u8.icon.uploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283bb38f')) {
      api.createRecord('283bb38f', component.options)
    } else {
      api.reload('283bb38f', component.options)
    }
    module.hot.accept("./u8.icon.uploader.vue?vue&type=template&id=283bb38f&", function () {
      api.rerender('283bb38f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/u8sdk/components/u8.icon.uploader.vue"
export default component.exports